import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      gallery: "Gallery",
      reviews: "Reviews",
      products: "Products",
      contact: "Contact",
      book: "Book Now",
    },
    hero: {
      eyebrow: "TTcuts Barbershop · Ii, Yliranta",
      title1: "Fresh cuts.",
      title2: "Real skill.",
      title3: "No compromise.",
      subtitle:
        "TTcuts is built from passion and precision. Every cut is done with care, style, and attention to detail. Clients leave confident, fresh, and satisfied.",
      cta: "Book Now",
      ctaSecondary: "View Services",
      scroll: "Scroll",
    },
    about: {
      eyebrow: "About / Meistä",
      title: "Built from passion. Sharpened by craft.",
      body:
        "TTcuts is a young, self-built barbershop brand built from passion, skill, and real hands-on work. Everything from the space to the craft is created with personal dedication. The goal is simple: sharp cuts, clean fades, and a relaxed atmosphere where every client feels confident leaving the chair.",
      stat1: "Years of craft",
      stat2: "Happy clients",
      stat3: "5★ reviews",
    },
    services: {
      eyebrow: "Services / Hinnasto",
      title: "Precision. Every cut.",
      micro:
        "Every cut is done with precision and attention to detail. No rushed work — only clean, sharp results.",
      items: [
        { name: "Hiustenleikkaus", desc: "Classic haircut", price: "25€" },
        { name: "Fade-leikkuu", desc: "Signature fade", price: "20€" },
        { name: "Parranajo / siistiminen", desc: "Beard trim & shave", price: "15€" },
        { name: "Muodonmuutos", desc: "Full transformation", price: "30€" },
        { name: "Hiustenleikkaus & parta", desc: "Cut + beard combo", price: "30€" },
        { name: "Design", desc: "Hair design add-on", price: "+5€" },
      ],
      cta: "Book your slot",
    },
    gallery: {
      eyebrow: "Gallery / Galleria",
      title: "The work speaks.",
      add: "Add photo",
    },
    reviews: {
      eyebrow: "Reviews / Asiakaspalaute",
      title: "What clients say.",
    },
    products: {
      eyebrow: "Products / Tuotteet",
      title: "Bandido — barber-grade.",
      desc:
        "Professional barber-grade styling products used for clean, long-lasting results.",
      cta: "Available in shop",
    },
    why: {
      eyebrow: "Why TTcuts",
      title: "Why clients choose TTcuts.",
      items: [
        "Precision fades and clean lines",
        "Consistent high-quality results",
        "Relaxed, friendly atmosphere",
        "Modern barber techniques",
        "Attention to detail in every cut",
        "Built from real passion and craft",
      ],
    },
    contact: {
      eyebrow: "Contact / Yhteystiedot",
      title: "Find the chair.",
      address: "Kivimaantie 19, Ii Yliranta, Finland",
      phone: "Phone",
      email: "Email",
      hours: "Hours",
      hoursValue: "Flexible · By appointment",
      socials: "Follow",
    },
    booking: {
      title: "Book your cut",
      subtitle: "Pick your time. Get fresh.",
      close: "Close",
    },
    footer: {
      tagline: "Sharp cuts. Clean fades. Built in Ii.",
      rights: "All rights reserved.",
    },
  },
  fi: {
    nav: {
      about: "Meistä",
      services: "Hinnasto",
      gallery: "Galleria",
      reviews: "Palaute",
      products: "Tuotteet",
      contact: "Yhteystiedot",
      book: "Varaa aika",
    },
    hero: {
      eyebrow: "TTcuts Barbershop · Ii, Yliranta",
      title1: "Tarkkaa työtä.",
      title2: "Aitoa fiilistä.",
      title3: "Huippufade.",
      subtitle:
        "TTcuts on rakennettu intohimosta ja tarkkuudesta. Jokainen leikkaus tehdään huolella, tyylillä ja yksityiskohtia kunnioittaen. Asiakas lähtee tuolilta tyytyväisenä ja fresh-fiiliksissä.",
      cta: "Varaa aika",
      ctaSecondary: "Katso palvelut",
      scroll: "Vieritä",
    },
    about: {
      eyebrow: "Meistä / About",
      title: "Rakennettu intohimosta. Hiottu käsityönä.",
      body:
        "TTcuts on nuori, itse rakennettu barbershop-brändi, joka on syntynyt intohimosta, taidosta ja oikeasta käsityöstä. Kaikki tilasta itse leikkaukseen on tehty omalla otteella. Tavoite on yksinkertainen: tarkat leikkaukset, puhtaat fadet ja rento tunnelma, jossa asiakas lähtee aina tyytyväisenä.",
      stat1: "Vuotta työtä",
      stat2: "tyytyväisiä asiakkaita",
      stat3: "5★ arvostelua",
    },
    services: {
      eyebrow: "Hinnasto / Services",
      title: "Tarkkuutta. Joka leikkauksessa.",
      micro:
        "Jokainen leikkaus tehdään tarkasti ja yksityiskohdat huomioiden. Ei kiirettä — vain puhdas ja terävä lopputulos.",
      items: [
        { name: "Hiustenleikkaus", desc: "Klassinen leikkaus", price: "25€" },
        { name: "Fade-leikkuu", desc: "Häivytys leikkaus", price: "20€" },
        { name: "Parranajo / siistiminen", desc: "Parta ja siistiminen", price: "15€" },
        { name: "Muodonmuutos", desc: "Täydellinen muutos", price: "30€" },
        { name: "Hiustenleikkaus & parta", desc: "Leikkaus + parta", price: "30€" },
        { name: "Design", desc: "Hiusdesign-lisä", price: "+5€" },
      ],
      cta: "Varaa vuoro",
    },
    gallery: {
      eyebrow: "Galleria / Gallery",
      title: "Työ puhukoon puolestaan.",
      add: "Lisää kuva",
    },
    reviews: {
      eyebrow: "Palaute / Reviews",
      title: "Mitä asiakkaat sanovat.",
    },
    products: {
      eyebrow: "Tuotteet / Products",
      title: "Bandido — ammattilaisen valinta.",
      desc:
        "Ammattilaisen muotoilutuotteet puhtaaseen ja kestävään lopputulokseen.",
      cta: "Saatavilla liikkeessä",
    },
    why: {
      eyebrow: "Miksi TTcuts",
      title: "Miksi asiakkaat valitsevat TTcuts.",
      items: [
        "Tarkat fadet ja puhtaat linjat",
        "Tasaisen korkea laatu joka kerta",
        "Rento ja ystävällinen tunnelma",
        "Modernit barber-tekniikat",
        "Yksityiskohdat huomioidaan aina",
        "Rakennettu aidosta intohimosta",
      ],
    },
    contact: {
      eyebrow: "Yhteystiedot / Contact",
      title: "Löydä tuoli.",
      address: "Kivimaantie 19, Ii Yliranta, Suomi",
      phone: "Puhelin",
      email: "Sähköposti",
      hours: "Aukioloajat",
      hoursValue: "Joustavat · Ajanvarauksella",
      socials: "Seuraa",
    },
    booking: {
      title: "Varaa leikkauksesi",
      subtitle: "Valitse aika. Tule fresheinä ulos.",
      close: "Sulje",
    },
    footer: {
      tagline: "Tarkat leikkaukset. Puhtaat fadet. Rakennettu Iissä.",
      rights: "Kaikki oikeudet pidätetään.",
    },
  },
};

const LanguageContext = createContext({ lang: "en", t: translations.en, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const stored = localStorage.getItem("ttcuts-lang");
    if (stored && translations[stored]) {
      setLang(stored);
      return;
    }
    const browser = (navigator.language || "en").toLowerCase();
    if (browser.startsWith("fi")) setLang("fi");
  }, []);

  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("ttcuts-lang", l);
  };

  return (
    <LanguageContext.Provider value={{ lang, t: translations[lang], setLang: changeLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
